/**
 *
 * @module AnalyticsPluginEvents enum
 * @desc Analytics evnt enum
 *
 */
export default {
    ANALYTICS_PLUGIN_LOADED: 'analyticsPluginLoaded',
    ANALYTICS_PLUGIN_ERROR: 'analyticsPluginError',
    ANALYTICS_ERROR: 'analyticsError',
    ANALYTICS_LOADED: 'analyticsLoaded',
};
